import { useMemo } from 'react';

const useRootElement = () => {
  const rootElement = useMemo(getRootElement, []);
  return { element: rootElement, isIframe: rootElement.id === 'root' };
};

export default useRootElement;

const getRootElement = () => {
  //  Проверка, если body id PollSite - тогда это сайт, иначе iframe
  return document.body.id === 'PollsSite'
    ? document.getElementsByClassName('center')[0]!
    : document.getElementById('root')!;
};
